import { FormControl, FormControlLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material"

export function DefaultActionSelector({ value, onChange }) {
    return (
        <Stack spacing={1}>
            <Typography variant="subtitle1" fontWeight={600}>
                Default Action
            </Typography>
            <Typography variant="body2" color="text.secondary">
                Tasks that do not match any rule will use this default action.
            </Typography>
            <FormControl>
                <RadioGroup value={value} onChange={handleChange}>
                    <FormControlLabel
                        value="include"
                        control={<Radio size="small" />}
                        label="Start with all tasks included"
                    />
                    <FormControlLabel
                        value="exclude"
                        control={<Radio size="small" />}
                        label="Start with all tasks excluded"
                    />
                </RadioGroup>
            </FormControl>
        </Stack>
    )

    function handleChange(e) {
        onChange(e.target.value)
    }
}
